const ProfileType = {
    PLC: "plc",
    PLB: "plb",
    PT: "pt",
};
  
export default ProfileType;
  